module.exports = __webpack_public_path__ + "static/6-8b51a2fa0c833230bc0890b6ece93119.jpg";